import * as core from '../../../../../../../core'
import * as sr from '../sr'

export const RESOURCE = {
  payload: {
    alias: 'award-details',
    appAlias: sr.RESOURCE.payload.alias,
    description: 'Award Details',
    display: {
      isMain: false,
      position: 5,
    },
    name: 'Award Details',
    page: { alias: 'sr:award-details' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
